/**
 * @fileoverview Custom Product Selector: `.ctp-tab` uses `data-tab-target` matching the panel `#id`
 * inside `<custom-tab-product-selector>`.
 */
const SELECTOR_TAB = '.ctp-tab';
const SELECTOR_PANEL = '.ctp-panel';
const ATTR_TAB_TARGET = 'tabTarget';
const TAG_NAME = 'custom-tab-product-selector';
/** Must match `CLASS_SHOWING_DETAIL` in `custom-quick-add-new.js`. */
const CLASS_CTP_DETAIL_OPEN = 'is-showing-detail';

class CustomTabProductSelector extends HTMLElement {
    #abortController = null;

    connectedCallback() {
        this.#abortController?.abort();
        this.#abortController = new AbortController();
        this.addEventListener('click', this.#handleClick, {signal: this.#abortController.signal});
    }

    disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = null;
    }

    #handleClick = event => {
        const tab = event.target?.closest(SELECTOR_TAB);
        if (!(tab instanceof HTMLElement) || !this.contains(tab)) return;

        const targetId = tab.dataset[ATTR_TAB_TARGET];
        if (!targetId) return;

        const panel = this.querySelector(`#${targetId}`);
        if (!(panel instanceof HTMLElement)) return;

        this.querySelectorAll(SELECTOR_TAB).forEach(node => node.classList.toggle('active', node === tab));
        this.querySelectorAll(SELECTOR_PANEL).forEach(node => {
            const isActive = node === panel;
            node.classList.toggle('active', isActive);
            if (isActive) node.removeAttribute('aria-hidden');
            else node.setAttribute('aria-hidden', 'true');
        });

        const closeDetail = window.__ctpCloseProductDetail;
        if (typeof closeDetail === 'function') {
            this.querySelectorAll(`${SELECTOR_PANEL}:not(.active)`).forEach(inactivePanel => {
                inactivePanel.querySelectorAll('.ctp-product-root').forEach(root => {
                    if (root.classList.contains(CLASS_CTP_DETAIL_OPEN)) closeDetail(root);
                });
            });
        }
    };
}

if (!customElements.get(TAG_NAME)) {
    customElements.define(TAG_NAME, CustomTabProductSelector);
}
